// src/api-config.js
let API_URL;
let simulationStart;
console.log('config.js', process.env.NODE_ENV)
if (process.env.NODE_ENV === "production") {
    API_URL = process.env.REACT_APP_PROD_API_URL;
} else {
    API_URL = process.env.REACT_APP_DEV_API_URL;
}


API_URL = "https://apis.qrtsolutions.com"
// API_URL = "http://localhost:80"



//simulationStart = true;
simulationStart = false;

export { API_URL, simulationStart };
